const likesCommentOmnitureCalls = {
    callOmniture: function (eventLocation) {
        var host = window.location.origin;
        //remove the event and page information because merged data stays in SFLY_DTL
        if (!window.$omnitureDTL) {
            return;
        }
        window.$omnitureDTL.removeOmnitureJSPData(host, "event");

        //wait till some JSP posts omniture data into the DTL buffer
        window.$omnitureDTL.processOmnitureJSPData(null);

        window.$omnitureDTL.putOmnitureJSPData(host, {
            event: {
                eventInfo: {
                    eventName: 'generic event'
                },
                eventDetails: {
                    eventLocation: eventLocation,

                }
            }
        });
    }
}

export default likesCommentOmnitureCalls;